const StarRating = ({ type = 'filled' }: { type?: 'filled' | 'outline' }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.28347 1.54592C5.57692 0.951326 6.42479 0.951327 6.71825 1.54592L7.82997 3.79853L10.3159 4.15976C10.9721 4.2551 11.2341 5.06148 10.7592 5.52431L8.96043 7.27772L9.38507 9.75358C9.49716 10.4071 8.81122 10.9055 8.22431 10.5969L6.00086 9.42798L3.7774 10.5969C3.19049 10.9055 2.50455 10.4071 2.61664 9.75358L3.04128 7.27772L1.24246 5.52431C0.767651 5.06148 1.02966 4.2551 1.68584 4.15976L4.17174 3.79853L5.28347 1.54592Z"
        fill={type === 'filled' ? 'white' : 'transparent'}
        stroke={type === 'outline' ? '#262626' : 'transparent'}
      />
    </svg>
  );
};
export default StarRating;
